import React from "react";
import { Link } from "react-router-dom";
import "./AdminDashboard.css"; // Neues Styling für Admin-Dashboard


const AdminDashboard = () => {
  return (
    <div className="admin-dashboard-container">
      <h1 className="admin-title">Admin Dashboard</h1>
      <p className="admin-subtitle">Verwaltung</p>

      <div className="admin-buttons">
        <Link to="/privatadmin/teambuilder" className="admin-button red">
           Teambuilder Admin
        </Link>
        <Link to="/privatadmin/teamcomps" className="admin-button blue">
           Teamcomps erstellen
        </Link>
        <Link to="/privatadmin/teamcompdashboard" className="admin-button green">
          teamcomps löschen
        </Link>
        <Link to="/privatadmin/admincommteams" className="admin-button yellow">
          CommBuilder
        </Link>
        <Link to="/statistics" className="admin-button yellow">
          Statistiken
        </Link>
      </div>
    </div>
  );
};

export default AdminDashboard;
